export default __webpack_public_path__ + "static/media/WimbledonCommon_2021_COVER.21f5a6db.jpg";